import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import { useShopStage } from '@hooks';
import { routing } from '@utils/routing';
import { addUtmSourceParamToUrl } from '@utils/url';
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss';
import checkOutTheHelpCenter from '../assets/check-out-the-help-center.png';
export const useVisitHelpCenterRecommendation = () => {
    const { shopStage, isLoading: isLoadingShopStage } = useShopStage();
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    return {
        visitHelpCenterRecommendation: {
            id: 'helpCenter',
            enabled: shopStage.stage2 && recommendationsDismiss.helpCenter.visible,
            isLoading: isLoadingShopStage,
            suggestion: (React.createElement(Suggestion, { title: "Check out the Help Center", description: "Access helpful tips and resources.", buttonLabel: "Visit help center", buttonHref: addUtmSourceParamToUrl(routing.external.helpCenter.self, 'onboarding'), buttonTarget: "_blank", imageUrl: checkOutTheHelpCenter, analytics: "visitHelpCenter", onDismiss: createOnDismiss(recommendationsDismiss.helpCenter.dismiss) })),
        },
    };
};
